import { IApiService } from '../services/api_service';

export const email = (centralApi: IApiService) => ({
  post: (data = null) => {
    return centralApi.post('/email', data, {
      contentType: false,
    });
  }
});
